import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { ODATATYPE_TO_APP_PLATFORM } from '../../app/util/intune/appProtectionPolicies'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const url = '/secure/policies/intune/deviceAppManagement-managedAppPolicies'

export const intuneAppPoliciesApi = createApi({
  reducerPath: 'intuneAppPolicies',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getIntuneAppPolicies: builder.query({
      query: (customerId) => ({
        url,
        params: { customerId },
      }),
    }),
    getIntuneAppPolicyById: builder.query({
      query: ({ customerId, policyId, platform }) => ({
        url: `${url}/${policyId}`,
        params: { customerId, platform },
      }),
    }),
    deleteAppPolicy: builder.mutation({
      query: ({ customerId, userId, policyId }) => ({
        url,
        params: { customerId, userId, policyId },
        method: 'DELETE',
      }),
    }),
    createAppPolicy: builder.mutation({
      query: ({ customerId, userId, payload }) => ({
        url,
        body: payload,
        params: { customerId, userId },
        method: 'POST',
      }),
    }),
  }),
})

export const {
  useGetIntuneAppPoliciesQuery,
  useLazyGetIntuneAppPoliciesQuery,
  useGetIntuneAppPolicyByIdQuery,
  useLazyGetIntuneAppPolicyByIdQuery,
  useDeleteAppPolicyMutation,
  useCreateAppPolicyMutation,
} = intuneAppPoliciesApi

export const useGetIntuneAppPolicies = () => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetIntuneAppPoliciesQuery(customerId)
}

export const useGetIntuneAppPolicyById = ({ policyId, platform }, options) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetIntuneAppPolicyByIdQuery({ customerId, policyId, platform }, options)
}

export const useAppProtectionPolicies = () => {
  const { data } = useGetIntuneAppPolicies()

  // filter by protection policies that we support, app policies also come with configurations that have different odata.type
  return data?.filter((item) => ODATATYPE_TO_APP_PLATFORM[item?.['@odata.type']]) ?? []
}
